var React = require('react');

function Flushed (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M248,8C111,8,0,119,0,256S111,504,248,504,496,393,496,256,385,8,248,8ZM80,224a72,72,0,1,1,72,72,72,72,0,0,1-72-72ZM312,400H184c-21.2,0-21.2-32,0-32H312C333.2,368,333.2,400,312,400Zm32-104a72,72,0,1,1,72-72,72,72,0,0,1-72,72Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M152,200a23.94,23.94,0,1,0,.12,0Zm192,0a23.94,23.94,0,1,0,.12,0Z","className":"fa-primary","key":2})]);
}

Flushed.defaultProps = {"viewBox":"0 0 496 512","className":"icon"};

module.exports = Flushed;

Flushed.default = Flushed;
